
class Header {
    constructor(container) {
        this.container = container;
        this.mainContainer = container.querySelector('main')
        this.mobileMenuToggles = container.querySelectorAll('[mobile-nav-toggle]');
        this.mobileMenuItemToggles = container.querySelectorAll('[mobile-menu-item-toggle]');
        this.searchIcon = container.querySelector('.js-show-search')
        this.closeSearchIcon = container.querySelector('.search-close')
        this.headerContainer = container.querySelector('.header')
        this.init();
    }

    init() {
        this.handleHamburgerMenu();
        this.handleMenuItem();
        this.handleSearchIcon();
        this.handleStickyHeader()
    }

    handleHamburgerMenu() {
        this.mobileMenuToggles.forEach(toggle => {
            toggle.addEventListener("click", (e) => {
                this.container.classList.toggle('open')
            })
        })
    }

    handleMenuItem() {
        $('.mob-heading').click(function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass("expanded");
        });
        $('.mobile-child').slideUp(200);
    }

    handleSearchIcon() {
        this.searchIcon.addEventListener("click", () => {
            $('#search-pop').toggleClass("show");
            this.searchIcon.style.visibility = 'hidden';
            this.closeSearchIcon.style.display = 'block';
        })

        this.closeSearchIcon.addEventListener("click", () => {
            $('#search-pop').toggleClass("show");
            this.searchIcon.style.visibility = 'visible';
            this.closeSearchIcon.style.display = 'none';
        })
    }

    handleStickyHeader() {
        const header = this.headerContainer
        const announcementBarHeight = document.querySelector('[announcement-bar]').offsetHeight;
        let headerHeight = header.offsetHeight;

        window.addEventListener('scroll', () => {
            if(window.scrollY > headerHeight + announcementBarHeight) {
                header.classList.add('sticky');
                this.mainContainer.style.paddingTop = `${headerHeight}px`;
            } else {
                header.classList.remove('sticky');
                this.mainContainer.style.paddingTop = 0;
            }    
        })

    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Header (
        document.body
    )
})
